module.exports = __webpack_public_path__ + "img/greencross.45eaf27d.svg";